/**
 * PURPOSE: Editar una celda de color dentro de la matriz de uniformes.
 * RESPONSIBILITIES: Mostrar estado modificado y propagar cambios de texto; solo lectura con opciones normalizadas (FTR-0014).
 * COLLABORATORS: UniformMatrix.jsx.
 * ROUTE: winscore/src/components/UniformMatrix/UniformMatrixCell.jsx
 */
import React from "react";

export function UniformMatrixCell({ value, dirty, onChange, readOnly = false }) {
  return (
    <input
      type="text"
      value={value}
      onChange={(event) => onChange(event.target.value)}
      readOnly={readOnly}
      placeholder={readOnly ? "" : "Color"}
      className={`w-36 rounded-lg border px-3 py-2 text-sm text-gray-800 outline-none transition-all duration-150 placeholder:text-gray-400
        focus:border-indigo-400 focus:ring-2 focus:ring-indigo-100 focus:bg-white
        ${
          dirty
            ? "border-indigo-200 bg-indigo-50"
            : "border-gray-200 bg-white hover:border-gray-300"
        }`}
    />
  );
}